import { render, staticRenderFns } from "./ResizableImageNodeView.vue?vue&type=template&id=08b55fc2&scoped=true"
import script from "./ResizableImageNodeView.vue?vue&type=script&lang=js"
export * from "./ResizableImageNodeView.vue?vue&type=script&lang=js"
import style0 from "./ResizableImageNodeView.vue?vue&type=style&index=0&id=08b55fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b55fc2",
  null
  
)

export default component.exports